import React from 'react';

export const Title = ({ children, className = '' }) => (
    <h2
        className={`
        px-4 lg:px-2 xl:px-0 
        text-xl l:text-2xl lg:text-3xl
        font-mardoto-bold text-orange
        mb-12 
        text-center
        ${className}
    `}
    >
        {children}
    </h2>
);

export const SubTitle = ({ children, className = '' }) => (
    <h3
        className={`
        ${className}
        text-center 
        px-4 lg:px-2 xl:px-0 
        text-base lg:text-xl 
        text-gray-800 
        font-mardoto-bold 
        mb-12
    `}
    >
        {children}
    </h3>
);

export const MainText = ({ children, className = '' }) => (
    <div
        className={`
        px-4 lg:px-2 xl:px-0 
        mb-4 xl:mb-8
        text-sm md:text-base
        text-gray-800 leading-loose tracking-wide 
        ${className}
    `}
    >
        {children}
    </div>
);